import { IGame } from "@grassrootly/api/entities";
import { UpdateGameScorePayload } from "@grassrootly/api/gateways";
import withErrorCheck from "../CheckError";
import server from "../Server";

export const UpdateGameScore = async (payload: UpdateGameScorePayload): Promise<Omit<IGame, "group" | "attendees">> => {
  return withErrorCheck(
    await server
      .from("Games")
      .update({
        host_score: payload.hostScore,
        visitor_score: payload.visitorScore,
      })
      .eq("id", payload.gameId)
      .select()
  )[0];
};
